import moment from 'moment';

export default {
    code: "en",
    messages: {
        min_date: (field, { min, format = 'DD/MM/YYYY' } = {}) => {
            var minDate = moment(min, format);
            return "The " + field + " cannot be before " + minDate.format(format);
        }
    }
}